export default __webpack_public_path__ + "static/FTRegolaNeue-Bold-f8590d85d6f20c7e7ce65c3667f5007e.woff";